export default {
      id: "viber-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.1792148661250.svg#viber-usage",
      toString: function () {
        return this.url;
      }
    }